module.exports = __webpack_public_path__ + "static/media/grid-item-b8.ce027142.png";